module.exports = __webpack_public_path__ + "media/success.ab0bf413.wav";